import { render, staticRenderFns } from "./foldModel.vue?vue&type=template&id=62cafd47&scoped=true&"
import script from "./foldModel.vue?vue&type=script&lang=js&"
export * from "./foldModel.vue?vue&type=script&lang=js&"
import style0 from "./foldModel.vue?vue&type=style&index=0&id=62cafd47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cafd47",
  null
  
)

export default component.exports